import Link from "next/link";
import { Trans } from "next-i18next";

import { LINKS } from "@/constants/links";

export const TermsAndConditions = ({ i18nKey = "terms_and_conditions" }) => (
  <Trans
    ns="common"
    i18nKey={i18nKey}
    components={{
      termsLink: <Link href={LINKS.TERMS}>terms</Link>,
      privacyLink: <Link href={LINKS.PRIVACY}>privacy</Link>,
    }}
  />
);
